angular.module('core')
    .controller('VerifyCancelAssignmentModalController', ['$scope', '$modalInstance', '$filter', 'lessonData', function($scope, $modalInstance, $filter, $lessonData) {

        var DBL_STANDARD_ID = 2;

        $scope.lessonData = $lessonData;

        // @INFO: Helpful info on how angular modals should work
        // http://stackoverflow.com/questions/19743299/what-is-the-difference-between-dismiss-a-modal-and-close-a-modal-in-angular
        // http://plnkr.co/edit/xMTr78WJQbKyHsA53gyv?p=preview
        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function() {
            $modalInstance.dismiss('canceled by user');
        };

        $scope.description = $filter('edxAssignmentTitleTranslate')($scope.lessonData);

        $scope.assigner = $scope.lessonData.teacher_first_name + " " + $scope.lessonData.teacher_last_name;
    }]);
